<template>
  <div class="workorder-index page-search-table" v-loading="loading">
    <div class="header">
      <div class="search">
        <condition-filters
          ref="conditionFilters"
          :model="currentSearch"
          @submit="doSearch"
        >
          <template v-slot="scope">
            <div class="row">
              <div class="label">工单状态</div>
              <div class="cont">
                <el-select size="small" v-model="scope.condition.status">
                  <el-option
                    v-for="item in workorderStatus"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="row">
              <div class="label">工单类型</div>
              <div class="cont">
                <el-select size="small" v-model="scope.condition.type">
                  <el-option
                    v-for="item in workorderType"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="row">
              <div class="label">开始日期</div>
              <div class="cont">
                <el-date-picker
                  type="date"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  v-model="scope.condition.startTime"
                  size="small"
                ></el-date-picker>
              </div>
            </div>
            <div class="row">
              <div class="label">结束日期</div>
              <div class="cont">
                <el-date-picker
                  type="date"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  v-model="scope.condition.endTime"
                  size="small"
                ></el-date-picker>
              </div>
            </div>
          </template>
        </condition-filters>
        <el-tag
          v-if="
            currentSearch.status !== null && currentSearch.status !== undefined
          "
          closable
          @close="currentSearch.status = undefined"
          size="small"
          type="success"
        >
          {{ getNameOfWorkorderStatus(currentSearch.status) }}
        </el-tag>
        <el-tag
          v-if="currentSearch.type !== null && currentSearch.type !== undefined"
          closable
          @close="currentSearch.type = undefined"
          size="small"
          type="success"
        >
          {{ getNameOfWorkorderType(currentSearch.type) }}
        </el-tag>
        <el-tag
          v-if="currentSearch.startTime"
          closable
          @close="currentSearch.startTime = undefined"
          size="small"
          type="success"
          >{{ currentSearch.startTime }}</el-tag
        >
        <el-tag
          v-if="currentSearch.endTime"
          closable
          @close="currentSearch.endTime = undefined"
          size="small"
          type="success"
          >{{ currentSearch.endTime }}</el-tag
        >
      </div>
      <div class="actions"></div>
    </div>
    <div class="statistic">
      <div>
        <div class="label">未受理</div>
        <div class="text">--</div>
      </div>
      <div>
        <div class="label">受理中</div>
        <div class="text">--</div>
      </div>
      <div>
        <div class="label">已办结</div>
        <div class="text">--</div>
      </div>
      <div>
        <div class="label">计划工单</div>
        <div class="text">--</div>
      </div>
    </div>
    <el-tabs v-model="currentTab" @tab-click="onTabClick">
      <el-tab-pane
        v-for="item in tabs"
        :key="item"
        :label="item"
        :name="item"
      ></el-tab-pane>
    </el-tabs>
    <div class="table">
      <div class="table-wrapper">
        <el-table :data="list" stripe style="width: 100%" height="100%">
          <el-table-column prop="index" label="#" align="center" width="60">
          </el-table-column>
          <el-table-column
            prop="number"
            label="工单编号"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column label="工单生成时间">
            <template slot-scope="scope">
              {{ Utils.dateFormat(scope.row.create_time, "MM-DD HH:mm") }}
            </template>
          </el-table-column>
          <el-table-column prop="user_name" label="服务对象"> </el-table-column>
          <el-table-column label="工单类型">
            <template slot-scope="scope">
              {{ getNameOfWorkorderType(scope.row.type) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="time"
            label="受理时长"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              <div
                class="workorder-status"
                :class="`status-${scope.row.status}`"
              >
                {{ getNameOfWorkorderStatus(scope.row.status) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="handler_name" label="话务员" width="120">
          </el-table-column>
          <el-table-column
            prop="operation"
            label="操作"
            fixed="right"
            width="80"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="checkDetail(scope.row)"
                ><i class="iconfont iconxiangqing"></i
              ></el-button>
              <el-button
                type="text"
                @click="closeOrder(scope.row)"
                v-if="+scope.row.status === 2"
                ><i class="iconfont iconquxiaodingdan"></i
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-pagination
      @size-change="loadData(1, arguments[0])"
      @current-change="loadData(arguments[0])"
      :current-page="pagination.index"
      :page-sizes="[20, 50, 100, 200]"
      :page-size="pagination.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    ></el-pagination>
  </div>
</template>

<script>
import _ from 'lodash'
import ConditionFilters from '@/components/partial/ConditionFilters'
export default {
  components: { ConditionFilters },
  data() {
    return {
      currentTab: '所有数据',
      tabs: ['所有数据', '搜索结果'],
      loading: false,
      currentSearch: {},
      pagination: {
        index: 1,
        size: 20,
        total: 0
      },
      list: []
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    closeOrder(row) {
      this.$confirm('确定关闭此工单吗？').then(() => {
        this.loading = true
        this.Service.call('workorder/close', 'GET', { id: row.oid }).then(() => {
          this.$message.success('工单关闭成功')
          this.loadData(this.pagination.index, this.pagination.size)
        }).catch(() => {
          this.loading = false
        })
      })
    },
    checkDetail(row) {
      this.routeTo({ path: '/orders/workorder/detail', query: { oid: row._id.$oid } })
    },
    onTabClick() {
      this.loadData()
    },
    doSearch(form) {
      if (_.isNil(form.status) && !form.type && !form.startTime && !form.endTime) {
        this.$message.error('请至少选择或者输入一个搜索条件')
        return
      }
      this.$refs.conditionFilters.close()
      this.$set(this.currentSearch, 'status', form.status)
      this.$set(this.currentSearch, 'type', form.type)
      this.$set(this.currentSearch, 'startTime', form.startTime)
      this.$set(this.currentSearch, 'endTime', form.endTime)
      this.currentTab = this.tabs[1]
    },
    loadData(pageIndex, pageSize) {
      pageIndex = (pageIndex || 1) - 1
      let query = { index: pageIndex || 0, size: pageSize || this.pagination.size }
      if (this.currentTab === '搜索结果') {
        query = { ...query, ...this.currentSearch }
        if (this.Utils.isObjectEmpty(this.currentSearch)) {
          this.list = []
          this.pagination.index = 1
          this.pagination.total = 0
          return
        }
      }
      this.loading = true
      query = { ...query, title: "坐席工单" }
      this.Service.call('workorder', 'GET', query).then(data => {
        this.pagination = {
          index: data.index + 1,
          size: data.size,
          total: data.total
        }
        let list = data.data || []
        _.forEach(list, (item, idx) => {
          item.index = idx + 1
          item.create_time = item.create_time && item.create_time.$date
          if (item.finish_time && item.finish_time.$date) {
            item.finish_time = item.finish_time && item.finish_time.$date
            let t = item.finish_time - item.create_time
            if (t) {
              item.time = this.Utils.formatTime(t)
            }
          }
        })
        this.list = list
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    currentSearch: {
      deep: true,
      handler() {
        if (this.Utils.isObjectEmpty(this.currentSearch)) {
          this.currentTab = this.tabs[0]
        } else {
          this.currentTab = this.tabs[1]
        }
        this.loadData()
      }
    }
  }
}
</script>
